"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

/**
 * Displays items next to menu drawer.
 */
class Grip extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hidden-lg",
      style: {
        display: 'inline-block',
        marginLeft: '5px',
        float: 'right'
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      onClick: this.props.toggleMenu,
      className: "menu-toggle-grip",
      style: {
        display: 'block',
        height: '75px',
        padding: '25px 5px',
        fontSize: '16px',
        color: '#fff',
        textDecoration: 'none',
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        width: '30px',
        display: 'inline-block',
        marginTop: '3px'
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "pull-right",
      src: this.props.open ? 'https://www.concur.com/sites/all/modules/custom_concur/concur_responsive_menu/images/mob-ico-close.png' : 'https://www.concur.com/sites/all/modules/custom_concur/concur_responsive_menu/images/mob-ico-ham.png'
    }))));
  }
}
exports.default = Grip;
Grip.propTypes = {
  dropdownLabel: _propTypes.default.string,
  open: _propTypes.default.bool,
  toggleMenu: _propTypes.default.func
};
Grip.defaultProps = {
  dropdownLabel: 'MENU'
};